














































import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";

import { MODULE_COLORS } from "@/utility/Constants";

export default Vue.extend({
    props: { showDialog: Boolean, templateName: String, loading: Boolean, fromSecurity: Boolean },
    data() {
        return { moment, MODULE_COLORS };
    },
    computed: {
        ...mapGetters(["longDateFormat"]),
        showDeleteTemplateDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
            },
        },
    },
});
